import React from "react";
import PropTypes from "prop-types";
import styles from "components/common/edit-columns-modal.scss";
import { Modal } from "./modal";
import { Button } from "./button";
import { ColumnsEditor } from "./columns-editor";

export const EditColumnsModal = ({
  isEditColumnsVisible,
  columns,
  onClose,
  onReturnToDefaultColumns,
  onToggleColumn
}) => (
  <Modal
    isVisible={ isEditColumnsVisible }
    onClose={ onClose }
    transitionName={ "edit-documents-columns" }
  >
    <ColumnsEditor columns={ columns } onToggle={ onToggleColumn } />
    <div className={ styles.actions }>
      <Button link onClick={ onReturnToDefaultColumns }>Return to defaults</Button>
      <Button onClick={ onClose } primary>Done</Button>
    </div>
  </Modal>
);

EditColumnsModal.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  isEditColumnsVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onReturnToDefaultColumns: PropTypes.func.isRequired,
  onToggleColumn: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/common/edit-columns-modal.jsx